import type { App, Directive } from 'vue'
import { permission } from './permission'

// 自定义指令
const directives: Record<string, Directive> = {
  permission,
}

export default {
  install(app: App) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key])
    })
  },
}
